/**
 * タブ index (targetIndex) の side 側へドロップしたときの、移動後の最終 index を返す。
 * sourceIndex がターゲットより前にある場合、そのタブを配列から抜くと後続の index が
 * 1つずつ手前にずれるため raw から 1 引く。
 */
export function resolveTabDropIndex(
	sourceIndex: number,
	targetIndex: number,
	side: "before" | "after",
): number {
	const raw = side === "before" ? targetIndex : targetIndex + 1;
	return sourceIndex < raw ? raw - 1 : raw;
}
